module.exports = __webpack_public_path__ + "img/max-person-search.aa67edab.svg";